<h2 mat-dialog-title>
    {{ targetPromptSet ? 'Import into "' + targetPromptSet.name + '"' : 'Import Prompt Sets from Excel' }}
</h2>
<div mat-dialog-content>
    @if (targetPromptSet) {
    <div class="warning-banner">
        <mat-icon>warning</mat-icon>
        <div class="warning-text">
            <strong>Important:</strong> If you previously exported prompts and are re-importing them, please delete all existing prompts first to avoid duplicates. Importing will add new prompts without removing existing ones.
        </div>
    </div>
    }

    <div *ngIf="targetPromptSet; else newPromptSetsHelp">
        <p>Upload an .xlsx file to import prompts into <strong>{{ targetPromptSet.name }}</strong>. The <strong>PromptSetName</strong> column will be ignored — all prompts will be added to this prompt set.</p>
        <p>The file may also include <strong>OutputSchema</strong> and <strong>SummaryPrompt*</strong> columns to update the output schema and summary prompt for this prompt set.</p>
    </div>
    <ng-template #newPromptSetsHelp>
        <p>Please upload an .xlsx file with the structure shown below. You can leave PromptSetName empty to add multiple prompts to the same set. PromptIdentifier will be auto-generated from PromptName.</p>
        <p>The file may also include <strong>OutputSchema</strong>, <strong>SummaryPromptName</strong>, <strong>SummaryPromptContext</strong>, <strong>SummaryPromptContent</strong>, and <strong>SummaryPromptInputFields</strong> columns to import output schemas and summary prompts for each prompt set.</p>
    </ng-template>

    <div class="template-section">
        <h3>Excel template</h3>
        <p>Copy this header and example rows into Excel, then fill in your data:</p>
        <div class="template-table-wrapper">
            <table class="template-table">
                <thead>
                    <tr>
                        <th *ngIf="!targetPromptSet">PromptSetName</th>
                        <th>PromptName</th>
                        <th>Context</th>
                        <th>Prompt</th>
                        <th>OutputSchema</th>
                        <th>SummaryPromptName</th>
                        <th>SummaryPromptContext</th>
                        <th>SummaryPromptContent</th>
                        <th>SummaryPromptInputFields</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td *ngIf="!targetPromptSet">Prompt Set 1</td>
                        <td>Prompt Name 1</td>
                        <td>Example content...</td>
                        <td>Example content...</td>
                        <td>[{{"{"}}...{{"}"}}]</td>
                        <td>Summary Prompt</td>
                        <td>Context...</td>
                        <td>Content...</td>
                        <td>field1, field2</td>
                    </tr>
                    <tr>
                        <td *ngIf="!targetPromptSet"></td>
                        <td>Prompt Name 2</td>
                        <td>Example content...</td>
                        <td>Example content...</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                    <tr *ngIf="!targetPromptSet">
                        <td>Prompt Set 2</td>
                        <td>Prompt Name 3</td>
                        <td>Example content...</td>
                        <td>Example content...</td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="upload-row">
        <button mat-stroked-button color="primary" (click)="fileInput.click()" [disabled]="isImporting">
            <mat-icon>file_upload</mat-icon>
            Choose Excel (.xlsx)
        </button>
        <span class="file-name" *ngIf="fileName">{{ fileName }}</span>
        <button mat-icon-button color="warn" *ngIf="fileName" (click)="clearFile()" [disabled]="isImporting" title="Remove file">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <input #fileInput type="file" accept=".xlsx" (change)="onFilePicked($event)" hidden>

    <div *ngIf="parsedRows.length" class="summary">
        <mat-icon color="primary">check_circle</mat-icon>
        Loaded {{parsedRows.length}} rows
    </div>

    <mat-progress-bar *ngIf="isImporting" mode="indeterminate"></mat-progress-bar>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="cancel()" [disabled]="isImporting">Cancel</button>
    <button mat-flat-button color="primary" (click)="startImport()" [disabled]="!parsedRows.length || isImporting">Import</button>
</div>
